import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { EXPLORE_ORDER, SECTIONS } from "@/lib/sections";

export function ExploreGrid() {
  return (
    <section className="mx-auto mt-20 w-full cs-rise" style={{ animationDelay: "120ms" }} data-testid="explore-section">
      <div className="mb-4 flex items-baseline justify-between">
        <h2 className="text-base font-medium text-zinc-100 md:text-lg">Explore</h2>
        <span className="text-xs text-zinc-600">More capabilities arrive in later phases</span>
      </div>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-5">
        {EXPLORE_ORDER.map((key) => {
          const s = SECTIONS[key];
          const Icon = s.icon;
          const id = key === "chats" ? "chat" : key;
          return (
            <Link
              key={key}
              to={s.path}
              data-testid={`explore-card-${id}`}
              className="group flex min-h-[104px] flex-col rounded-xl border border-white/[0.08] bg-ink-850 p-4 transition-colors hover:border-white/[0.15] hover:bg-ink-800"
            >
              <div className="flex items-start justify-between">
                <Icon className="h-[22px] w-[22px] text-zinc-200" strokeWidth={1.5} />
                <ChevronRight className="h-4 w-4 text-zinc-600 transition-transform group-hover:translate-x-0.5 group-hover:text-zinc-400" />
              </div>
              <div className="mt-auto pt-4">
                <div className="flex items-center gap-2 text-[14.5px] font-medium text-white">
                  {key === "chats" ? "Chat" : s.label}
                  {!s.live && <span className="rounded-full border border-white/10 px-1.5 py-px text-[10px] font-normal text-zinc-500">Planned</span>}
                </div>
                <p className="mt-1 text-[12.5px] leading-snug text-zinc-500">{s.blurb}</p>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
